var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSinglePageDynamic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353 353",
    style: {
      enableBackground: "new 0 0 353 353"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.2,352.2h-20.3c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9h20.3c3.8,0,6.9,3.1,6.9,6.9S225,352.2,221.2,352.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.3,352.2h-65.7c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9h65.7c1.6,0,3-1.3,3-3V18.1c0-1.7-1.3-3-3-3H18.1 c-1.7,0-3,1.4-3,3v317.2c0,1.7,1.4,3,3,3h65.7c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9H18.1c-9.3,0-16.9-7.5-16.9-16.8V18.1 c0-9.3,7.6-16.9,16.9-16.9h317.2c9.3,0,16.8,7.6,16.8,16.9v317.2C352.2,344.6,344.6,352.2,335.3,352.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5,352.2h-20.3c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9h20.3c3.8,0,6.9,3.1,6.9,6.9S156.3,352.2,152.5,352.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M345.2,98.1H8.2c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9h337.1c3.8,0,6.9,3.1,6.9,6.9S349.1,98.1,345.2,98.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308.7,56.6H168.7c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9h140.1c3.8,0,6.9,3.1,6.9,6.9S312.6,56.6,308.7,56.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8,56.6h-8.1c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9h8.1c3.8,0,6.9,3.1,6.9,6.9S56.6,56.6,52.8,56.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7,56.6h-8.1c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9h8.1c3.8,0,6.9,3.1,6.9,6.9S95.5,56.6,91.7,56.6L91.7,56.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.5,56.6h-8.1c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9h8.1c3.8,0,6.9,3.1,6.9,6.9S134.4,56.6,130.5,56.6L130.5,56.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePageDynamic);
export default __webpack_public_path__ + "static/media/single-page-dynamic.cc9cc626616cbce7df0c31d999dfff61.svg";
export { ForwardRef as ReactComponent };